module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"remove-filter":"Fjern filter %label%: %value%"},"de":{"remove-filter":"Filter entfernen %label%: %value%"},"fr":{"remove-filter":"Supprimer le filtre %label%: %value%"},"nl":{"remove-filter":"Filter verwijderen %label%: %value%"}}')
  delete Component.options._Ctor
}
